<template>
    <div class="d-flex flex-column justify-center">
        <v-dialog v-model="dialog" width="500" persistent>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="warning"
                >
                    Alterar tarifa
                </v-btn>
            </template>
            <v-card>
                <v-card-title class="title-color">Alterar Tarifa</v-card-title>
                <v-card-text class="py-0 px-6">
                    <v-form ref="changeFareForm" @submit.prevent="onSubmit()">
                        <div class="mb-2 mt-4">
                            <span>Por favor, informe o novo <b>valor da tarifa diária</b>:</span>
                        </div>
                        <v-text-field
                            v-model="newFarePrice"
                            @input="formatPrice()"
                            :rules="fareRule"
                            outlined
                            prepend-inner-icon="mdi-currency-brl"
                            hide-details="auto"
                        />
                        <v-checkbox v-model="mustChangeFarePriceInHotelRoom" class="mt-1">
                            <template v-slot:label>
                                <span class="fs-14">Alterar tarifa no cadastro do quarto</span>
                            </template>
                        </v-checkbox>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pt-2 pb-8 px-8">
                    <v-row class="justify-end">
                        <v-btn color="error" @click="closeDialog()">Cancelar</v-btn>
                        <v-btn class="ml-4" color="success" @click="onSubmit()">Confirmar</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog width="500" v-model="warnDialog" persistent>
            <v-card>
                <v-card-title class="title-color">
                    <v-icon size="md" color="white">mdi-alert</v-icon>
                    <span class="ml-2">Confira as alterações!</span>
                </v-card-title>
                <v-card-text class="py-4">
                    <template>
                        <v-row>
                            <v-col cols="12">
                                <v-list two-line class="py-0">
                                    <template v-for="(item) in changesToWarn">
                                        <v-list-item class="px-1">
                                            <v-list-item-avatar>
                                                <v-icon color="blue" large>
                                                    {{ item.icon }}
                                                </v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title class="text-wrap">
                                                    {{ item.title }}
                                                </v-list-item-title>
                                                <v-list-item-subtitle class="text-wrap">
                                                    {{ item.subtitle }}
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-list>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
                <v-card-actions class="justify-end pb-4">
                    <v-btn color="error" @click="warnDialog = false">Cancelar</v-btn>
                    <v-btn
                        class="ml-2"
                        color="success"
                        :loading="loading"
                        @click="changeBookingFare()"
                    >
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <response-dialog
            :model="responseDialog"
            :message="responseMessage"
            :type="responseType"
            @close="closeAndReload()"
        />
    </div>
</template>

<script>
import ResponseDialog from "../../../components/Dialog/ResponseDialog.vue";

export default {
    name: "ChangeBookingFare",
    components: {ResponseDialog},
    props: ['booking'],
    data: () => ({
        dialog: false,
        newFarePrice: null,
        loading: false,
        warnDialog: false,
        fareRule: [
            v => !!v || 'O valor da tarifa é obrigatorio',
        ],
        responseDialog: false,
        responseMessage: '',
        responseType: '',
        mustChangeFarePriceInHotelRoom: false
    }),
    computed: {
        newFarePriceAsNumber() {
            return !!this.newFarePrice ? Number(this.newFarePrice.replace( /\D/g, '')) : null;
        },
        totalBookingValue() {
            return !!this.booking.total_value ? Number(this.booking.total_value.replace( /\D/g, '')) : null;
        },
        hasToWarnValueChange() {
            const fiftyPercent = this.totalBookingValue * 0.5;
            return this.newFarePriceAsNumber < fiftyPercent
                || this.newFarePriceAsNumber > fiftyPercent + this.totalBookingValue;
        },
        changesToWarn () {
            const changes = {
                hasToWarnValueChange: {
                    title: 'Tarifa da reserva',
                    subtitle: `O novo valor da diária desta reserva será de R$ ${this.newFarePrice}`,
                    icon: 'mdi-cash-multiple'
                },
                mustChangeFarePriceInHotelRoom: {
                    title: 'Tarifa no cadastro do quarto',
                    subtitle: `O novo valor da diária no cadastro deste quarto será de R$ ${this.newFarePrice}`,
                    icon: 'mdi-office-building'
                }
            };

            return Object.keys(changes)
                .filter(key => this[key])
                .map(key => changes[key]);
        }
    },
    methods: {
        formatPrice() {
            this.newFarePrice = new Intl.NumberFormat('pt-BR', {
                minimumFractionDigits: 2
            }).format(Number(this.newFarePrice.replace(/\D/g, ''))/100);
        },
        onSubmit() {
            if (!this.$refs.changeFareForm.validate()) return;
            if (this.hasToWarnValueChange || this.mustChangeFarePriceInHotelRoom) {
                this.warnDialog = true;
                return 0;
            }
            this.changeBookingFare();
        },
        changeBookingFare() {
            this.loading = true;
            const newFareValue = this.newFarePrice.replace(/\D/g, '');
            axios.patch('/api/booking/change-fare-price', {
                bookingId: this.booking.id,
                farePrice: newFareValue,
                mustChangeFarePriceInHotelRoom: this.mustChangeFarePriceInHotelRoom ? 1 : 0,
                fareId: this.booking.fare.id
            }).then((res) => {
                const responseData = res.data ? res.data : res;
                this.responseDialog = true;
                this.responseMessage = responseData.message;
                this.responseType = 'success';
            }).catch((err) => {
                const errorData = err.data ?? err;
                this.responseDialog = true;
                this.responseMessage = errorData.message;
                this.responseType = 'error';
            }).finally(() => {
                this.loading = false;
            });
        },
        closeDialog() {
            this.dialog = false;
            this.newFarePrice = null;
        },
        closeAndReload() {
            this.responseDialog = false;
            this.dialog = false;
            this.warnDialog = false;
            window.location.reload();
        }
    }
}
</script>

<style scoped>
.title-color {
    background-color: #fb8c00;
    color: white;
    font-weight: bold;
}
.fs-14 {
    font-size: 14px;
}
</style>
